import React, { Fragment } from 'react';
import { PlusCircle } from 'react-feather';
import { Container, Row, Col, Card } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Btn } from '../../../AbstractElements';
import TryoutBox from './TryoutBox';
import { useSelector, useDispatch } from 'react-redux';
import TryoutFilter from '../Common/TryoutFilter';
import { resetState } from '../../../Features/Learning/Tryout/addTryoutSlice';

const TryoutContain = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const cards = useSelector(state => state.Tryout.data.data)
  const handleAdd = (e) => {
    dispatch(resetState());
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Col md="12" className="project-list">
          {cards && (
          <Card>
            <Row>
              <Col>
                <Link to={`${process.env.PUBLIC_URL}/learning/tryout-add`} onClick={handleAdd}>
                  <Btn attrBtn={{ color: 'primary' }}> 
                    <i className="fa fa-plus-circle fa-lg"></i> Tambah Tryout Baru
                  </Btn>
                </Link>
              </Col>
            </Row>
          </Card>
          )}
        </Col>
        <Row className='learning-block'>
          <Col xl="9" className='xl-80'>
            <Row>
              <TryoutBox />
            </Row>
          </Col>
          {cards && (
          <TryoutFilter />
          )}
        </Row>
      </Container>
    </Fragment>
  );
};
export default TryoutContain;